import React from 'react'
import styles from './internal.module.css'
import { DownloadSchemaButton } from '../layout/DownloadSchemaButton/DownloadSchemaButton.tsx'
import { useSwaggerLimitedRelease } from '../../hooks'

const DecodeApiDownloadSchema = () => {
  const { nodes: nodesLimitedRelease } = useSwaggerLimitedRelease()
  const title = 'QR codes provider'
  const downloadSchemaTitle = title.toLowerCase().replace(/ /g, '-')
  const downloadSchemaFile = nodesLimitedRelease
    .filter((ctx) => ctx.info.title === title)
    .map((node) => node)

  return (
    <div className={styles.page}>
      <h1>{title}</h1>
      <DownloadSchemaButton
        fileObject={downloadSchemaFile}
        fileTitle={`${downloadSchemaTitle}`}
      />
    </div>
  )
}

export default DecodeApiDownloadSchema
